import { ia_agents_mock } from "@/store/modules/ia_agents_mock";

// services/ia_agents_store.ts
export interface ia_agent {
  id: string;
  name: string;
  description: string;
  category: string;
  empezar: string; // Frase inicial personalizada
  icon: string; // emoji o código corto
  tags: string[]; // ["ventas","bmc"]
  systemPrompt: string; // texto completo del System Prompt
  isPublic: boolean; // visible en "Explorar" (solo UI local)
  createdAt: number;
  updatedAt: number;
  // Tipo de agente
  kind?: "llm" | "http";

  // Configuración HTTP (solo si kind === "http")
  http?: {
    url: string;
    method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
    headers?: Record<string, string>;
    bodyTemplate?: string;    // admite {{input}}
    resultPath?: string;      // dot path (ej: "data.result")
    timeoutMs?: number;
    authType?: "none" | "basic" | "bearer";
    authUser?: string;
    authPassword?: string;
    authToken?: string;
  };
}

const LS_KEY = "marketplace_agents";

function readAll(): ia_agent[] {
  try {
    const raw = localStorage.getItem(LS_KEY);
    let stored: ia_agent[] = raw ? JSON.parse(raw) : [];
    const all = [...stored];
    ia_agents_mock.forEach((mock) => {
      if (!all.some((a) => a.id === mock.id)) all.push(mock);
    });
    // Saneo mínimo para agentes antiguos
    for (let i = 0; i < all.length; i++) {
      const a = all[i];
      a.kind = a.kind || "llm";
      if (a.kind === "http" && a.http) {
        a.http.method = a.http.method || "POST";
        a.http.headers = a.http.headers || {};
        a.http.bodyTemplate = a.http.bodyTemplate || "";
        a.http.resultPath = a.http.resultPath || "";
        a.http.timeoutMs = typeof a.http.timeoutMs === "number" ? a.http.timeoutMs : 15000;
        a.http.authType = a.http.authType || "none";
      }
    }
    return all;
  } catch {
    return ia_agents_mock.slice(0);
  }
}

function writeAll(items: ia_agent[]): void {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(items));
  } catch (e) {}
}

export const ia_agents_store = {
  list(): ia_agent[] {
    return readAll();
  },
  get(id: string): ia_agent | null {
    const all = readAll();
    console.log("Agentes",all);
    for (let i = 0; i < all.length; i++) {
      if (all[i].id === id) return all[i];
    }
    return null;
  },
  create(data: Omit<ia_agent, "id" | "createdAt" | "updatedAt">): ia_agent {
    const now = Date.now();
    const item: ia_agent = {
      id: String(now) + "_" + Math.floor(Math.random() * 100000),
      createdAt: now,
      updatedAt: now,
      name: data.name,
      description: data.description,
      category: data.category,
      icon: data.icon,
      empezar: data.empezar,
      tags: data.tags || [],
      systemPrompt: data.systemPrompt,
      isPublic: data.isPublic,
      // NUEVO
      kind: data.kind || "llm",
      http: data.http ? {
        url: data.http.url,
        method: data.http.method || "POST",
        headers: data.http.headers || {},
        bodyTemplate: data.http.bodyTemplate || "",
        resultPath: data.http.resultPath || "",
        timeoutMs: typeof data.http.timeoutMs === "number" ? data.http.timeoutMs : 15000,
        authType: data.http.authType || "none",
        authUser: data.http.authUser,
        authPassword: data.http.authPassword,
        authToken: data.http.authToken,
      } : undefined
    };
    const all = readAll();
    all.unshift(item);
    writeAll(all);
    return item;
  },
  update(id: string, patch: Partial<ia_agent>): ia_agent | null {
    const all = readAll();
    let changed = false;
    for (let i = 0; i < all.length; i++) {
      if (all[i].id === id) {
        const updated = Object.assign({}, all[i], patch, {
          updatedAt: Date.now(),
        });
        all[i] = updated;
        changed = true;
        break;
      }
    }
    if (changed) writeAll(all);
    return changed ? this.get(id) : null;
  },
  remove(id: string): void {
    const all = readAll().filter(function(x) {
      return x.id !== id;
    });
    writeAll(all);
  },
  duplicate(id: string): ia_agent | null {
    const orig = this.get(id);
    if (!orig) return null;
    return this.create({
      name: orig.name + " (copia)",
      description: orig.description,
      category: orig.category,
      icon: orig.icon,
      empezar: orig.empezar,
      tags: orig.tags.slice(0),
      systemPrompt: orig.systemPrompt,
      isPublic: orig.isPublic,
      // NUEVO
      kind: orig.kind || "llm",
      http: orig.http ? {
        url: orig.http.url,
        method: orig.http.method || "POST",
        headers: Object.assign({}, orig.http.headers || {}),
        bodyTemplate: orig.http.bodyTemplate || "",
        resultPath: orig.http.resultPath || "",
        timeoutMs: typeof orig.http.timeoutMs === "number" ? orig.http.timeoutMs : 15000,
        authType: orig.http.authType || "none",
        authUser: orig.http.authUser,
        authPassword: orig.http.authPassword,
        authToken: orig.http.authToken,
      } : undefined
    });
  },
};
